export enum HAS_HOSP_MOP {
  Y = 'Y',
  N = 'N',
}

export enum UNEXPIRED_HEALTH_CARD {
  Y = 'Y',
  N = 'N',
}

export enum CARD_PROVIDER {
  EA = 'Europe Assistance (EA)',
  IP = 'Inter Partner',
}
